import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	eventLabel: {
		id: 'customer-org-search-result.customer-org-label',
		defaultMessage: 'Customer Organization',
		description: 'Customer Organization subtype label',
	},
});
